import { Icon } from '@components/primitives/Icon'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { getTrialBriefSummary } from '@modules/trials/helpers/getTrialBriefSummary'
import type { TrialForSummaryCard } from '@modules/trials/types/TrialForSummaryCard'

import { generateDeterministicPreviousTreatmentStringFromPatientQuote } from './generateDeterministicPreviousTreatmentStringFromPatientQuote'

export default function TrialSummarySection({
  containerClassName,
  trial,
}: {
  containerClassName?: string
  trial: TrialForSummaryCard
}) {
  // Hiding patient quote until the data has been scrubbed for PHI RE: POW-9750
  // const hasPatientQuote =
  //   trial.patientQuote &&
  //   trial.patientQuote.length > 50 &&
  //   trial.patientQuote.length < 250
  const hasPatientQuote = false

  return (
    <div
      className={classMerge(
        'line-clamp-5 flex h-[136px] flex-col items-start justify-start',
        containerClassName,
      )}
    >
      {hasPatientQuote ? (
        <TrialPatientQuote trial={trial} />
      ) : (
        <TrialBriefSummary trial={trial} />
      )}
    </div>
  )
}

function TrialBriefSummary({ trial }: { trial: TrialForSummaryCard }) {
  const trialBriefSummary = getTrialBriefSummary({ ...trial })

  return (
    <Text
      className='text-neutral600'
      element='h5'
      styleName='p-tiny'
      value={trialBriefSummary}
    />
  )
}

function TrialPatientQuote({ trial }: { trial: TrialForSummaryCard }) {
  const patientQuote = trial.patientQuote

  const priorTreatment =
    generateDeterministicPreviousTreatmentStringFromPatientQuote(
      patientQuote ?? '',
    )

  return (
    <div className='flex flex-col items-start justify-center gap-y-4'>
      <Text
        className='text-neutral600'
        element='h5'
        styleName='p-tiny'
        value={`“${patientQuote}”`}
      />
      <div className='flex items-center gap-2'>
        <Icon
          className='rounded-full border border-neutral200 bg-neutral200 p-3 text-neutral600'
          icon={faUser}
          size='1x'
        />
        <div className='flex flex-col'>
          <Text
            className='text-black'
            styleName='p-tiny-strong'
            value='Patient'
          />
          <Text
            className='text-neutral400'
            styleName='p-tiny'
            value={priorTreatment}
          />
        </div>
      </div>
    </div>
  )
}
